import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard, AuthorizationGuard } from '@c4/auth';
import { DirectorReadyGuard } from '@c4/core';

import { SysmanComponent } from './sysman/sysman.component';
import { SysmanSddpDiscoveryComponent } from './sysman-sddp-discovery/sysman-sddp-discovery.component';
import { SysmanNetworkConfigComponent } from './sysman-network-config/sysman-network-config.component';
import { SysmanLogConfigComponent } from './sysman-log-config/sysman-log-config.component';
import { SysmanProcessStatusComponent } from './sysman-process-status/sysman-process-status.component';
import { SysmanVpnConfigComponent } from './sysman-vpn-config/sysman-vpn-config.component';
import { SysmanTimeConfigComponent } from './sysman-time-config/sysman-time-config.component';
import { SysmanOutputComponent } from './sysman-output/sysman-output.component';
import { SysmanSddpDeviceDetailComponent } from './sysman-sddp-device-detail/sysman-sddp-device-detail.component';
import { SysmanLogViewComponent } from './sysman-log-view/sysman-log-view.component';
import { SysmanPackageVersionsComponent } from './sysman-package-versions/sysman-package-versions.component';

export const SYSMAN_ROUTES: Routes = [
  // { path: '', redirectTo: 'sysman/disco', pathMatch: 'prefix' },
  {
    path: 'sysman',
    component: SysmanComponent,
    canActivate: [AuthenticationGuard, AuthorizationGuard, DirectorReadyGuard],
    canActivateChild: [AuthenticationGuard, AuthorizationGuard, DirectorReadyGuard],
    children: [
      { path: '', redirectTo: 'disco', pathMatch: 'prefix' },
      { path: 'disco', component: SysmanSddpDiscoveryComponent },
      { path: 'details', component: SysmanSddpDeviceDetailComponent },
      { path: 'network', component: SysmanNetworkConfigComponent },
      { path: 'logging', component: SysmanLogConfigComponent },
      { path: 'services', component: SysmanProcessStatusComponent },
      { path: 'setup', component: SysmanVpnConfigComponent },
      { path: 'time', component: SysmanTimeConfigComponent },
      { path: 'outputlog', component: SysmanOutputComponent },
      { path: 'viewlog', component: SysmanLogViewComponent },
      { path: 'packages', component: SysmanPackageVersionsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(SYSMAN_ROUTES)],
  exports: [RouterModule],
  providers: []
})
export class SysmanRoutesModule { }



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/app.routes.ts